var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 94.7 39.5",
    style: {
      enableBackground: "new 0 0 94.7 39.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0CBB7C;}\n\t.st1{fill:#1B2B25;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.3,20.2L20.6,0.5l-5.3,19.7l4.5,1.2L6.1,38.8l4.7-17.4L6.3,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.8,9.1c-1.3,0-2,0.6-2,1.9s0.2,1,0.5,1.4c0.3,0.3,0.8,0.5,1.5,0.5s1.1-0.2,1.4-0.5s0.5-0.8,0.5-1.4 C77.7,9.7,77.1,9.1,75.8,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.2,15.8h-2.9v16.4h2.9V15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.7,9.2h-2.9v23h2.9v-6.4l1.3-1.3l6.2,7.7h3.5l-7.5-9.4l6.6-7h-3.6l-6.6,7V9.3L83.7,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.6,15.8V24c0,0.7,0,1.5,0.2,2.2s0.4,1.3,0.7,1.9c0.3,0.5,0.7,1,1.2,1.3s1.1,0.5,1.8,0.5 c1.7,0,2.8-0.6,3.4-1.7c0.7-1.2,1-2.9,1-5.2v-7.1h2.9v16.4h-2.9v-2.1c-0.4,0.5-0.8,1-1.2,1.3c-1,0.7-2.2,1-3.7,1 c-1.5,0-2.1-0.2-3-0.7c-0.8-0.4-1.4-1-1.9-1.8s-0.8-1.7-1.1-2.7c-0.2-1-0.3-2.1-0.3-3.3l0,0v-8.2L59.6,15.8L59.6,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.2,9.2v23h3.1v-6.7l4.1-4.9l6.7,11.5h3.5l-8.1-13.9l7.8-9h-4L41.4,21V9.2L38.2,9.2L38.2,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.1,7.6h2.5l-2.2,2.9h-0.3c-3.9,0-7.1,3.2-7.1,7.1V24c0,2.4,1.2,4.6,3.1,5.9l-0.8,2.9C2.2,31.1,0,27.8,0,24 v-6.4c0-5.5,4.5-10,10-10L10.1,7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.9,8.6l-0.8,2.9c2.1,1.2,3.5,3.5,3.5,6.1V24c0,3.9-3.2,7.1-7.1,7.1h-1.4L12.9,34h3.6c5.5,0,10-4.5,10-10 v-6.4c0-4-2.3-7.4-5.7-9L20.9,8.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.671a679fa51428158163772cb998e460.svg";
export { ForwardRef as ReactComponent };